/* eslint-disable */
import { useContext, useState } from 'react';
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@material-ui/core';
import P, { shape } from 'prop-types';
import ConfirmationDialog from '../ConfirmationDialog';
import { MainContext } from '../../context/ApiContext';

const SummaryReport = ({ dataItems }) => {
  const {
    deleters: { deleteUser },
  } = useContext(MainContext);

  const formatDateHour = (item) => {
    if (item >= 24) {
      const days = Math.floor(item / 24);
      const remainder = item % 24;
      const hours = Math.floor(remainder);
      const minutes = Math.floor(60 * (remainder - hours));

      const daysString = days && days + 'D';
      const hoursString = hours && hours + 'H';
      const minutesString = minutes && minutes + 'M';
      return `${daysString || ''} ${hoursString || ''} ${minutesString || ''}`;
    } else {
      const remainder = item % 24;
      const hours = Math.floor(remainder);
      const minutes = Math.floor(60 * (remainder - hours));

      const hoursString = hours && hours + 'H';
      const minutesString = minutes && minutes + 'M';

      return `${hoursString || ''} ${minutesString || ''}`;
    }
  };

  return (
    <div>
      <div style={{ display: 'flex' }}>
        {/* <div style={{ fontWeight: 'bold', marginBottom: '10px' }}>{'Dados'}</div> */}
        <TableContainer component={Paper} style={{ marginRight: 80 }}>
          <Table aria-label="simple table">
            <TableBody>
              <TableRow>
                <TableCell />
                <TableCell />
                <TableCell />
                <TableCell style={{ fontWeight: 'bold' }}>Metas</TableCell>
              </TableRow>

              <TableRow>
                <TableCell>Quantidade de Leads puxados no período</TableCell>
                <TableCell
                  colspan={2}
                  style={{
                    color:
                      Number(dataItems.items['count_leads']) <
                      Number(
                        dataItems.items['resultGoals']['mt_segnovos_capture_leads'][0]['value'] *
                          dataItems.items['resultGoals']['quantity_brokers_in_leads']
                      )
                        ? 'red'
                        : 'green',
                  }}>
                  {dataItems.items['count_leads']}
                </TableCell>
                <TableCell
                  colspan={2}
                  style={{
                    fontWeight: 'bold',
                    display: 'flex',
                    alignItems: 'center',
                    justifyItems: 'center',
                    gap: '4px',
                  }}>
                  {dataItems.items['resultGoals']['mt_segnovos_capture_leads'][0]['value'] *
                    dataItems?.items['resultGoals']['quantity_brokers_in_leads']}
                  <Typography>({dataItems?.items['resultGoals']['quantity_brokers_in_leads']})</Typography>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Puxou e ligou no prazo</TableCell>
                <TableCell
                  style={{
                    color:
                      Number(
                        ((dataItems.items['leads_capture_on_time'] / dataItems.items['count_leads']) * 100).toFixed(2)
                      ) < Number(dataItems.items['resultGoals']['mt_segnovos_capture_leads_on_time_rate'][0]['value'])
                        ? 'red'
                        : 'green',
                  }}>
                  {((dataItems.items['leads_capture_on_time'] / dataItems.items['count_leads']) * 100).toFixed(2)}%
                </TableCell>
                <TableCell>{dataItems.items['leads_capture_on_time']}</TableCell>
                <TableCell colspan={2} style={{ fontWeight: 'bold' }}>
                  {dataItems.items['resultGoals']['mt_segnovos_capture_leads_on_time_rate'][0]['value']} %
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell style={{ display: 'flex' }}>
                  {dataItems.items['all_conections'] ? (
                    Number(((dataItems.items['all_conections'] / dataItems.items['count_leads']) * 100).toFixed(2)) <
                    Number(dataItems.items['resultGoals']['mt_segnovos_connected_leads'][0]['value']) ? (
                      <>
                        <p style={{ width: '20%', color: 'green' }}>Persistir +</p>
                        <p style={{ width: '80%', paddingLeft: '30px' }}>Conexões</p>
                      </>
                    ) : (
                      'Conexões'
                    )
                  ) : (
                    <>
                      <p style={{ width: '20%', color: 'green' }}>Persistir +</p>
                      <p style={{ width: '80%', paddingLeft: '30px' }}>Conexões</p>
                    </>
                  )}
                </TableCell>
                <TableCell
                  style={{
                    color:
                      Number(((dataItems.items['all_conections'] / dataItems.items['count_leads']) * 100).toFixed(2)) <
                      Number(dataItems.items['resultGoals']['mt_segnovos_connected_leads'][0]['value'])
                        ? 'red'
                        : 'green',
                  }}>
                  {((dataItems.items['all_conections'] / dataItems.items['count_leads']) * 100).toFixed(2)}%
                </TableCell>

                <TableCell>{dataItems.items['all_conections']}</TableCell>
                <TableCell colspan={2} style={{ fontWeight: 'bold' }}>
                  {dataItems.items['resultGoals']['mt_segnovos_connected_leads'][0]['value']} %
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell rowspan={4}>Conectou por onde</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Whatsapp</TableCell>

                <TableCell colspan={2}>Telefone/Celular</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>
                  {(
                    (dataItems.items['contact_whatsapp'] /
                      (dataItems.items['contact_whatsapp'] + dataItems.items['contact_tel_cel'])) *
                    100
                  ).toFixed(2)}
                  %
                </TableCell>

                <TableCell colspan={2}>
                  {(
                    (dataItems.items['contact_tel_cel'] /
                      (dataItems.items['contact_whatsapp'] + dataItems.items['contact_tel_cel'])) *
                    100
                  ).toFixed(2)}
                  %
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>{dataItems.items['contact_whatsapp']}</TableCell>
                <TableCell colspan={2}>{dataItems.items['contact_tel_cel']}</TableCell>
              </TableRow>

              <TableRow>
                <TableCell style={{ display: 'flex' }}>
                  {dataItems.items['quoted'] ? (
                    Number((dataItems.items['quoted'] / dataItems.items['all_conections']) * 100) <
                    Number(dataItems.items['resultGoals']['mt_segnovos_quoted_leads_rate'][0]['value']) ? (
                      <>
                        <p style={{ width: '20%', color: 'green' }}>Persuasão</p>
                        <p style={{ width: '80%', paddingLeft: '30px' }}>Cotações</p>
                      </>
                    ) : (
                      'Cotações'
                    )
                  ) : (
                    <>
                      <p style={{ width: '20%', color: 'green' }}>Persuasão</p>
                      <p style={{ width: '80%', paddingLeft: '30px' }}>Cotações</p>
                    </>
                  )}
                </TableCell>
                <TableCell
                  style={{
                    color:
                      Number((dataItems.items['quoted'] / dataItems.items['all_conections']) * 100) <
                      Number(dataItems.items['resultGoals']['mt_segnovos_quoted_leads_rate'][0]['value'])
                        ? 'red'
                        : 'green',
                  }}>
                  {((dataItems.items['quoted'] / dataItems.items['all_conections']) * 100).toFixed(2)}%
                </TableCell>
                <TableCell>{dataItems.items['quoted']}</TableCell>
                <TableCell style={{ fontWeight: 'bold' }}>
                  {dataItems.items['resultGoals']['mt_segnovos_quoted_leads_rate'][0]['value']}%
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell rowspan={4}>Mandou cotação por onde</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Whatsapp</TableCell>

                <TableCell colspan={2}>Telefone/Celular</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>
                  {(
                    (dataItems.items['quoted_whatsapp'] /
                      (dataItems.items['quoted_whatsapp'] + dataItems.items['quoted_tel_cel'])) *
                    100
                  ).toFixed(2)}
                  %
                </TableCell>

                <TableCell colspan={2}>
                  {(
                    (dataItems.items['quoted_tel_cel'] /
                      (dataItems.items['quoted_whatsapp'] + dataItems.items['quoted_tel_cel'])) *
                    100
                  ).toFixed(2)}
                  %
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>{dataItems.items['quoted_whatsapp']}</TableCell>
                <TableCell colspan={2}>{dataItems.items['quoted_tel_cel']}</TableCell>
              </TableRow>

              {/*  <TableRow>
                <TableCell>Cotou quanto tempo depois de puxar o lead</TableCell>
                <TableCell colspan={2}>{dataItems.items['average_of_sell_quotation_time']} horas</TableCell>
              </TableRow> */}

              <TableRow>
                <TableCell>Mandou cotação quanto tempo depois da conexão</TableCell>
                <TableCell
                  colspan={2}
                  style={{
                    color:
                      Number(dataItems.items['average_of_contact_after_quotation']) >
                      Number(dataItems.items['resultGoals']['mt_segnovos_quotation_hours_after_connection'][0]['value'])
                        ? 'red'
                        : 'green',
                  }}>
                  {formatDateHour(Number(dataItems.items['average_of_contact_after_quotation']))}
                </TableCell>
                <TableCell style={{ fontWeight: 'bold' }}>
                  {dataItems.items['resultGoals']['mt_segnovos_quotation_hours_after_connection'][0]['value']}{' '}
                  {Number(
                    dataItems.items['resultGoals']['mt_segnovos_quotation_hours_after_connection'][0]['value']
                  ) === 1
                    ? 'hora'
                    : 'horas'}
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell style={{ display: 'flex' }}>
                  {Number(dataItems.items['sales_quantity']) <
                  Number(dataItems.items['resultGoals']['mt_segnovos_insurance_sales'][0]['value']) ? (
                    <>
                      <p style={{ width: '20%', color: 'green' }}>Técnica de venda</p>
                      <p style={{ width: '80%', paddingLeft: '30px' }}>Vendas de Seguros (% é de leads puxados)</p>
                    </>
                  ) : (
                    'Vendas de Seguros (% é de leads puxados)'
                  )}
                </TableCell>
                <TableCell>
                  {((dataItems.items['sales_quantity'] / dataItems.items['count_leads']) * 100).toFixed(2)}%
                </TableCell>
                <TableCell
                  style={{
                    color:
                      Number(dataItems.items['sales_quantity']) <
                      Number(dataItems.items['resultGoals']['mt_segnovos_insurance_sales'][0]['value'])
                        ? 'red'
                        : 'green',
                  }}>
                  {dataItems.items['sales_quantity']} / {dataItems.items['count_leads']}
                </TableCell>
                <TableCell style={{ fontWeight: 'bold' }}>
                  {dataItems.items['resultGoals']['mt_segnovos_insurance_sales'][0]['value']}
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell rowspan={4}>Vendeu por onde</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Whatsapp</TableCell>
                <TableCell>Telefone/Celular</TableCell>
                <TableCell />
              </TableRow>
              <TableRow>
                <TableCell>
                  {(
                    (dataItems.items['sales_on_whatsapp'] /
                      (dataItems.items['sales_on_whatsapp'] + dataItems.items['sales_on_tel_cel'])) *
                    100
                  ).toFixed(2)}
                  %
                </TableCell>
                <TableCell>
                  {(
                    (dataItems.items['sales_on_tel_cel'] /
                      (dataItems.items['sales_on_whatsapp'] + dataItems.items['sales_on_tel_cel'])) *
                    100
                  ).toFixed(2)}
                  %
                </TableCell>
                <TableCell />
              </TableRow>
              <TableRow>
                <TableCell>{dataItems.items['sales_on_whatsapp']}</TableCell>
                <TableCell>{dataItems.items['sales_on_tel_cel']}</TableCell>
                <TableCell />
              </TableRow>

              <TableRow>
                <TableCell>Vendeu quanto tempo depois da cotação</TableCell>
                <TableCell
                  colspan={2}
                  style={{
                    color:
                      Number(dataItems.items['average_of_quotation_time']) >
                      Number(dataItems.items['resultGoals']['mt_segnovos_sold_after_days_quotation'][0]['value'])
                        ? 'red'
                        : 'green',
                  }}>
                  {formatDateHour(Number(dataItems.items['average_of_quotation_time']) * 24)}
                </TableCell>
                <TableCell colspan={2} style={{ fontWeight: 'bold' }}>
                  {dataItems.items['resultGoals']['mt_segnovos_sold_after_days_quotation'][0]['value']} dia
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell>Venda de backup car % e Número</TableCell>
                <TableCell>
                  {((dataItems.items['backup_car_sales'] / dataItems.items['sales_quantity']) * 100).toFixed(2)}%
                </TableCell>

                <TableCell
                  style={{
                    color:
                      Number(dataItems.items['backup_car_sales']) <
                      Number(dataItems.items['resultGoals']['mt_segnovos_backup_car_sales'][0]['value'])
                        ? 'red'
                        : 'green',
                  }}>
                  {dataItems.items['backup_car_sales']} / {dataItems.items['sales_quantity']}
                </TableCell>

                <TableCell colspan={2} style={{ fontWeight: 'bold' }}>
                  {dataItems.items['resultGoals']['mt_segnovos_backup_car_sales'][0]['value']}
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell>Tempo total médio da venda</TableCell>
                <TableCell
                  colspan={2}
                  style={{
                    color:
                      Number(dataItems.items['average_of_sales_time']) / 24 >
                      Number(dataItems.items['resultGoals']['mt_segnovos_average_sales_time_days'][0]['value'])
                        ? 'red'
                        : 'green',
                  }}>
                  {formatDateHour(Number(dataItems.items['average_of_sales_time']))}
                </TableCell>
                <TableCell style={{ fontWeight: 'bold' }}>
                  {dataItems.items['resultGoals']['mt_segnovos_average_sales_time_days'][0]['value']} dias
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell>Comissão média no período</TableCell>
                <TableCell
                  colSpan={2}
                  style={{
                    color:
                      Number(dataItems.newTableItems['average_comissions']) <
                      Number(dataItems.items['resultGoals']['mt_segnovos_average_commission_rate'][0]['value'])
                        ? 'red'
                        : 'green',
                  }}>
                  {dataItems.newTableItems['average_comissions']} %
                </TableCell>
                <TableCell style={{ fontWeight: 'bold' }}>
                  {dataItems.items['resultGoals']['mt_segnovos_average_commission_rate'][0]['value']} %
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell colSpan={3} style={{ textAlign: 'center' }}>
                  Motivos principais das perdas (3)
                </TableCell>
              </TableRow>

              {dataItems.items['lost_sale_causes'].length > 0 ? (
                <>
                  {dataItems.items['lost_sale_causes'][0] && (
                    <TableRow>
                      <TableCell>{`1) ${dataItems.items['lost_sale_causes'][0].value}`}</TableCell>
                      <TableCell colSpan={1}>{dataItems.items['lost_sale_causes'][0].quantity}</TableCell>
                      <TableCell>
                        {(
                          (dataItems.items['lost_sale_causes'][0].quantity / dataItems.items['lost_sales']) *
                          100
                        ).toFixed(2)}
                        %
                      </TableCell>
                    </TableRow>
                  )}

                  {dataItems.items['lost_sale_causes'][1] && (
                    <TableRow>
                      <TableCell>{`2) ${dataItems.items['lost_sale_causes'][1].value}`}</TableCell>
                      <TableCell colSpan={1}>{dataItems.items['lost_sale_causes'][1].quantity}</TableCell>
                      <TableCell>
                        {(
                          (dataItems.items['lost_sale_causes'][1].quantity / dataItems.items['lost_sales']) *
                          100
                        ).toFixed(2)}
                        %
                      </TableCell>
                    </TableRow>
                  )}

                  {dataItems.items['lost_sale_causes'][2] && (
                    <TableRow>
                      <TableCell>{`3) ${dataItems.items['lost_sale_causes'][2].value}`}</TableCell>
                      <TableCell colSpan={1}>{dataItems.items['lost_sale_causes'][2].quantity}</TableCell>
                      <TableCell>
                        {(
                          (dataItems.items['lost_sale_causes'][2].quantity / dataItems.items['lost_sales']) *
                          100
                        ).toFixed(2)}
                        %
                      </TableCell>
                    </TableRow>
                  )}
                </>
              ) : (
                <TableRow>
                  <TableCell>{`Não existem motivos de perda`}</TableCell>
                  <TableCell colSpan={3}>N/A</TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TableContainer component={Paper}>
          <Table>
            <TableBody>
              {/* <TableRow>
                <TableCell>Venda de seguros novos/externos no período</TableCell>
                <TableCell colSpan={3}>{dataItems.newTableItems['new_insurances_sells']} %</TableCell>
              </TableRow>*/}
              <TableRow>
                <TableCell />
                <TableCell />
                <TableCell />
                <TableCell style={{ fontWeight: 'bold' }}>Metas</TableCell>
              </TableRow>

              {!!dataItems.conversions['conversion_site_sitehub_app'] && (
                <TableRow>
                  <TableCell>Percentual de conversão de lead que chegou pelo site/suthub/app</TableCell>
                  <TableCell>
                    {dataItems.conversions['conversion_site_sitehub_app'].countItems} /{' '}
                    {dataItems.conversions['conversion_site_sitehub_app'].dividedBy}
                  </TableCell>
                  <TableCell
                    style={{
                      color:
                        Number(dataItems.conversions['conversion_site_sitehub_app'].average) <
                        Number(dataItems.items['resultGoals']['mt_segnovos_site_suthub_app'][0]['value'])
                          ? 'red'
                          : 'green',
                    }}>
                    {dataItems.conversions['conversion_site_sitehub_app'].average.toFixed(2)}%
                  </TableCell>
                  <TableCell style={{ fontWeight: 'bold' }}>
                    {dataItems.items['resultGoals']['mt_segnovos_site_suthub_app'][0]['value']}%
                  </TableCell>
                </TableRow>
              )}

              {!!dataItems.conversions['conversion_intern_extern'] && (
                <TableRow>
                  <TableCell>Percentual de conversão de lead que chegou por indicação int./ext.</TableCell>
                  <TableCell>
                    {dataItems.conversions['conversion_intern_extern'].countItems}/{' '}
                    {dataItems.conversions['conversion_intern_extern'].dividedBy}
                  </TableCell>
                  <TableCell
                    style={{
                      color:
                        Number(dataItems.conversions['conversion_intern_extern'].average) <
                        Number(dataItems.items['resultGoals']['mt_segnovos_indication_int_ext'][0]['value'])
                          ? 'red'
                          : 'green',
                    }}>
                    {dataItems.conversions['conversion_intern_extern'].average.toFixed(2)}%
                  </TableCell>
                  <TableCell style={{ fontWeight: 'bold' }}>
                    {dataItems.items['resultGoals']['mt_segnovos_indication_int_ext'][0]['value']}%
                  </TableCell>
                </TableRow>
              )}

              {!!dataItems.conversions['conversion_social_media'] && (
                <TableRow>
                  <TableCell>Percentual de conversão de lead que chegou por redes sociais</TableCell>
                  <TableCell>
                    {dataItems.conversions['conversion_social_media'].countItems}/{' '}
                    {dataItems.conversions['conversion_social_media'].dividedBy}
                  </TableCell>
                  <TableCell
                    style={{
                      color:
                        Number(dataItems.conversions['conversion_social_media'].average) <
                        Number(dataItems.items['resultGoals']['mt_segnovos_social_medias'][0]['value'])
                          ? 'red'
                          : 'green',
                    }}>
                    {dataItems.conversions['conversion_social_media'].average.toFixed(2)}%
                  </TableCell>
                  <TableCell style={{ fontWeight: 'bold' }}>
                    {dataItems.items['resultGoals']['mt_segnovos_social_medias'][0]['value']}%
                  </TableCell>
                </TableRow>
              )}

              {!!dataItems.conversions['conversion_mkt_cloud'] && (
                <TableRow>
                  <TableCell>Percentual de conversão de lead que chegou por marketing cloud</TableCell>
                  <TableCell>
                    {dataItems.conversions['conversion_mkt_cloud'].countItems} /{' '}
                    {dataItems.conversions['conversion_mkt_cloud'].dividedBy}
                  </TableCell>
                  <TableCell
                    style={{
                      color:
                        Number(dataItems.conversions['conversion_mkt_cloud'].average) <
                        Number(dataItems.items['resultGoals']['mt_segnovos_mkt_cloud'][0]['value'])
                          ? 'red'
                          : 'green',
                    }}>
                    {dataItems.conversions['conversion_mkt_cloud'].average.toFixed(2)}%
                  </TableCell>
                  <TableCell style={{ fontWeight: 'bold' }}>
                    {dataItems.items['resultGoals']['mt_segnovos_mkt_cloud'][0]['value']}%
                  </TableCell>
                </TableRow>
              )}

              {!!dataItems.conversions['conversion_white_label'] && (
                <TableRow>
                  <TableCell>Percentual de conversão de lead que chegou por white label</TableCell>
                  <TableCell>
                    {dataItems.conversions['conversion_white_label'].countItems} /{' '}
                    {dataItems.conversions['conversion_white_label'].dividedBy}
                  </TableCell>
                  <TableCell
                    style={{
                      color:
                        Number(dataItems.conversions['conversion_white_label'].average) <
                        Number(dataItems.items['resultGoals']['mt_segnovos_white_label'][0]['value'])
                          ? 'red'
                          : 'green',
                    }}>
                    {dataItems.conversions['conversion_white_label'].average.toFixed(2)}%
                  </TableCell>
                  <TableCell style={{ fontWeight: 'bold' }}>
                    {dataItems.items['resultGoals']['mt_segnovos_white_label'][0]['value']}%
                  </TableCell>
                </TableRow>
              )}

              {!!dataItems.conversions['conversion_chatbot'] && (
                <TableRow>
                  <TableCell>Percentual de conversão de lead que chegou por chatbot (blip)</TableCell>
                  <TableCell>
                    {dataItems.conversions['conversion_chatbot'].countItems} /{' '}
                    {dataItems.conversions['conversion_chatbot'].dividedBy}
                  </TableCell>
                  <TableCell
                    style={{
                      color:
                        Number(dataItems.conversions['conversion_chatbot'].average) <
                        Number(dataItems.items['resultGoals']['mt_segnovos_chatbot'][0]['value'])
                          ? 'red'
                          : 'green',
                    }}>
                    {dataItems.conversions['conversion_chatbot'].average.toFixed(2)}%
                  </TableCell>
                  <TableCell style={{ fontWeight: 'bold' }}>
                    {dataItems.items['resultGoals']['mt_segnovos_chatbot'][0]['value']}%
                  </TableCell>
                </TableRow>
              )}

              <TableRow>
                <TableCell rowspan={3}>
                  De todas as finalizações, as que não venderam gastaram o tempo médio a seguir do envio da cotação para
                  a finalização
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell colSpan={3} style={{ textAlign: 'center' }}>
                  {!!dataItems.newTableItems['notSoldresultDiffHoursQuoted']['groupHours'] &&
                    dataItems.newTableItems['notSoldresultDiffHoursQuoted']['groupHours']}{' '}
                  (
                  {dataItems.newTableItems['notSoldresultDiffHoursQuoted'].average !== 'N/A'
                    ? formatDateHour(Number(dataItems.newTableItems['notSoldresultDiffHoursQuoted'].average))
                    : 'N/A'}
                  )
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell colSpan={2}>
                  {dataItems.newTableItems['notSoldresultDiffHoursQuoted'].countItems} /{' '}
                  {dataItems.newTableItems['not_sold_count']}
                </TableCell>
                <TableCell colSpan={2}>
                  {(
                    (dataItems.newTableItems['notSoldresultDiffHoursQuoted'].countItems /
                      dataItems.newTableItems['not_sold_count']) *
                    100
                  ).toFixed(2)}
                  %
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell rowspan={4}>Conversão destas cotações enviadas por canal em %</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Whatsapp</TableCell>
                <TableCell>Telefone/Celular</TableCell>
                <TableCell />
              </TableRow>
              <TableRow>
                <TableCell>
                  {(
                    (dataItems.items['sales_on_whatsapp'] /
                      (dataItems.items['sales_on_whatsapp'] + dataItems.items['sales_on_tel_cel'])) *
                    100
                  ).toFixed(2)}
                  %
                </TableCell>
                <TableCell>
                  {(
                    (dataItems.items['sales_on_tel_cel'] /
                      (dataItems.items['sales_on_whatsapp'] + dataItems.items['sales_on_tel_cel'])) *
                    100
                  ).toFixed(2)}
                  %
                </TableCell>
                <TableCell />
              </TableRow>
              <TableRow>
                <TableCell>{dataItems.items['sales_on_whatsapp']}</TableCell>
                <TableCell>{dataItems.items['sales_on_tel_cel']}</TableCell>
                <TableCell />
              </TableRow>
              <TableRow>
                <TableCell rowspan={3}>
                  De todas as finalizações, as que venderam gastaram o tempo médio a seguir do envio da cotação para o
                  fechamento
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell colSpan={3} style={{ textAlign: 'center' }}>
                  {!!dataItems.newTableItems['resultDiffHoursQuoted']['groupHours'] &&
                    dataItems.newTableItems['resultDiffHoursQuoted']['groupHours']}{' '}
                  (
                  {dataItems.newTableItems['resultDiffHoursQuoted'].average !== 'N/A'
                    ? formatDateHour(dataItems.newTableItems['resultDiffHoursQuoted'].average)
                    : 'N/A'}
                  )
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell colSpan={2}>
                  {dataItems.newTableItems['resultDiffHoursQuoted'].countItems} / {dataItems.items['sales_quantity']}
                </TableCell>
                <TableCell colSpan={2}>
                  {(
                    (dataItems.newTableItems['resultDiffHoursQuoted'].countItems / dataItems.items['sales_quantity']) *
                    100
                  ).toFixed(2)}
                  %
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell rowspan={3}>
                  De todas as finalizações, as que venderam gastaram o tempo médio a seguir desde que puxou e finalizou
                  o lead (tempo total da venda, do início ao fim)
                </TableCell>
              </TableRow>

              <TableRow>
                {console.log(dataItems.newTableItems['resultCapturedDiffHours'])}
                <TableCell colSpan={3} style={{ textAlign: 'center' }}>
                  {!!dataItems.newTableItems['resultCapturedDiffHours']['groupHours'] &&
                    dataItems.newTableItems['resultCapturedDiffHours']['groupHours']}{' '}
                  (
                  {dataItems.newTableItems['resultCapturedDiffHours'].average !== 'N/A'
                    ? formatDateHour(dataItems.newTableItems['resultCapturedDiffHours'].average)
                    : 'N/A'}
                  )
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell colSpan={2}>
                  {dataItems.newTableItems['resultCapturedDiffHours'].countItems} / {dataItems.items['sales_quantity']}
                </TableCell>
                <TableCell colSpan={2}>
                  {(
                    (dataItems.newTableItems['resultCapturedDiffHours'].countItems /
                      dataItems.items['sales_quantity']) *
                    100
                  ).toFixed(2)}
                  %
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell>% conversão (Cnt) Cel/Tel / (Cot) Cel/Tel / (Ven) Cel/Tel</TableCell>
                <TableCell colSpan={3}>{dataItems.conversions['conversion_on_cel_tel']} %</TableCell>
              </TableRow>

              <TableRow>
                <TableCell>% conversão (Cnt) Whatsapp / (Cot) Cel/Tel / (Ven) Cel/Tel</TableCell>
                <TableCell colSpan={3}>{dataItems.conversions['conversion_on_wpp_cel_tel']} %</TableCell>
              </TableRow>

              <TableRow>
                <TableCell>% conversão (Cnt) Whatsapp / (Cot) Whatsapp / (Ven) Whatsapp</TableCell>
                <TableCell colSpan={3}>{dataItems.conversions['conversion_on_wpp']} %</TableCell>
              </TableRow>

              <TableRow>
                <TableCell>% conversão (Cnt) Whatsapp / (Cot) Whatsapp / (Ven) Cel/Tel</TableCell>
                <TableCell colSpan={3}>{dataItems.conversions['conversion_on_wpp_wpp_cel_tel']} %</TableCell>
              </TableRow>

              <TableRow>
                <TableCell>% conversão (Cnt) Whatsapp / (Cot) Cel/Tel / (Ven) Whatsapp</TableCell>
                <TableCell colSpan={3}>{dataItems.conversions['conversion_on_wpp_cel_tel_wpp']} %</TableCell>
              </TableRow>

              <TableRow>
                <TableCell>% conversão (Cnt) Cel/Tel / (Cot) Whatsapp / (Ven) Whatsapp</TableCell>
                <TableCell colSpan={3}>{dataItems.conversions['conversion_on_cel_tel_wpp_wpp']} %</TableCell>
              </TableRow>

              <TableRow>
                <TableCell>% conversão (Cnt) Cel/Tel / (Cot) Whatsapp / (Ven) Cel/Tel</TableCell>
                <TableCell colSpan={3}>{dataItems.conversions['conversion_on_cel_tel_wpp_cel_tel']} %</TableCell>
              </TableRow>

              <TableRow>
                <TableCell>% conversão (Cnt) Cel/Tel / (Cot) Cel/Tel / (Ven) Whatsapp</TableCell>
                <TableCell colSpan={3}>{dataItems.conversions['conversion_on_cel_tel_wpp']} %</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </div>
  );
};

SummaryReport.propTypes = {
  listItem: P.arrayOf(
    shape({
      id: P.number,
    })
  ),
  title: P.string.isRequired,
};

SummaryReport.defaultProps = {
  listItem: null,
};

export default SummaryReport;
